import { CreateService, CRUDServiceInterface } from '@/services/service';
import { LessonEntity } from '@/entities/lesson.entity';

export default class LessonService
  extends CreateService<LessonEntity>('lesson')
  implements CRUDServiceInterface<LessonEntity>
{
  async getMany(): Promise<LessonEntity[]> {
    const [items] = await this.apiBuilder.getMany();
    return items;
  }
}
